import 'mdn-polyfills/NodeList.prototype.forEach';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { Pagination } from 'swiper/modules';

export default class Slider {
  constructor(element) {
    this.element = element;
    this.next = this.element.querySelector(".swiper-button-next .c-button");
    this.prev = this.element.querySelector(".swiper-button-prev .c-button");
    this.pagination = this.element.querySelector(".swiper-pagination");
    this.isMobil;

    this.swiperElement = this.element;

    this.swiperFractionBox;
    this.swiperFractionIndex;
    this.swiperFractionTotal;

    this.innerWidth = window.innerWidth;

    this.handleResize = this.handleResize.bind(this);

    this.spaceBetweenValues = 12;

    this.slidesPerView = "auto";
    this.loop = true;
    this.centeredSlides = false;

    this.breakpoints;

    this.sliderHeight;
    this.introHeight;

    this.lightboxImages;

    if (this.swiperElement.classList.contains("c-slider--card")) {
      this.spaceBetweenValues = 20;
    }

    if (this.swiperElement.classList.contains("c-slider--navigation")) {
      this.next = this.element.nextElementSibling.querySelector(".swiper-button-next .c-button");
      this.prev = this.element.nextElementSibling.querySelector(".swiper-button-prev .c-button");
      this.loop = false;
    }

    if (this.swiperElement.classList.contains("c-slider--logo")) {
      this.next = this.element.previousElementSibling.querySelector(".swiper-button-next .c-button");
      this.prev = this.element.previousElementSibling.querySelector(".swiper-button-prev .c-button");

      if (this.swiperElement.classList.contains("c-slider--logo-text")) {

        this.spaceBetweenValues = 20;
        this.slidesPerView = "1";
        this.breakpoints = {
          560: {
            slidesPerView: 2,
          },
          760: {
            slidesPerView: 3,
          },
          960: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        };
      }
      else {
        if (this.swiperElement.classList.contains("c-slider--logo-form")) {

          this.slidesPerView = "2";
          this.spaceBetweenValues = 20;
          this.breakpoints = {
            760: {
              slidesPerView: 3,
            },
            960: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          };

        } else {

          this.slidesPerView = "2";
          this.spaceBetweenValues = 20;
          this.breakpoints = {
            760: {
              slidesPerView: 3,
            },
            960: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          };
        }
      }
    }

    this.settings = {
      modules: [Navigation,Pagination],
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      pagination: {
        el: this.pagination,
      },
      on: {
        init: (swiper) => {
        },
        click:(swiper)=> {
          if (document.querySelector(".c-slider--navigation")) {
            if (document.querySelector(".c-slider--navigation").style.display !== 'none') {
              // console.log(swiper.clickedSlide);
              // swiper.slideToLoop(parseInt(swiper.clickedSlide.dataset.swiperSlideIndex, 10));
              swiper.slideTo(swiper.clickedIndex);
            }
          }
        },
        slideChange: (swiper) => {
        },
        realIndexChange:(swiper)=> {
          if (document.querySelector(".c-slider--image")) {
            this.swiperFractionIndex= swiper.realIndex;
            this.swiperFractionBox.innerHTML= (this.swiperFractionIndex + 1) + "/"+ this.swiperFractionTotal;
          }

          if (document.querySelector(".c-slider--navigation")) {
            if (document.querySelector(".c-slider--navigation").style.display !== 'none') {
              this.lightboxImages = document.querySelectorAll(".c-lightbox__image");
              for (let i = 0; i < this.lightboxImages.length; i++) {
                const element = this.lightboxImages[i];
                element.style.display="none";
              }
              this.lightboxImages[(swiper.realIndex)].style.display="block";
            }

          }

        }
      },
      centeredSlides: this.centeredSlides,
      slidesPerView: this.slidesPerView ,
      watchSlidesProgress: true,
      spaceBetween: this.spaceBetweenValues,
      loop: this.loop,
      breakpoints: this.breakpoints,

    };

    this.swiper;
  }

  handleResize() {
    if (document.querySelector(".c-slider--image")) {
      this.sliderHeight = document.querySelector(".c-slider--image").offsetHeight;
      document.documentElement.style.setProperty('--slider-height', `${this.sliderHeight}px`);
      this.introHeight = document.querySelector(".c-intro").offsetHeight;
      document.documentElement.style.setProperty('--intro-height', `${this.introHeight}px`);

      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if (viewportWidth > 960) {
        if (this.isMobil) {
          this.isMobil = false;
          if (!this.swiperElement.classList.contains("c-slider--navigation")) {
            this.swiper.destroy();
          }else {
            let element = document.querySelector(".swiper.c-slider--navigation");
            const slider = new Slider(element);
            slider.mount(element);
          }
        }
      } else {
        if (!this.isMobil) {
          this.isMobil = true;
          if (!this.swiperElement.classList.contains("c-slider--image")) {
            this.swiper.destroy();
          }else {
            let element = document.querySelector(".swiper.c-slider--image");
            const slider = new Slider(element);
            slider.mount(element);
          }
        }
      }
    }
  }

  mount() {
    this.settings = {
      ...this.settings,
    }

    this.swiper = new Swiper(this.swiperElement, this.settings);
    window.addEventListener('resize', this.handleResize);


    if (document.querySelector(".c-slider--image")) {
      this.sliderHeight = document.querySelector(".c-slider--image").offsetHeight;
      document.documentElement.style.setProperty('--slider-height', `${this.sliderHeight}px`);
      this.introHeight = document.querySelector(".c-intro").offsetHeight;
      document.documentElement.style.setProperty('--intro-height', `${this.introHeight}px`);

      if (this.swiperElement.classList.contains("c-slider--image")) {
        this.swiperFractionBox = document.querySelector(".swiper-pagination-top");
      }
    }

    if (document.querySelector(".c-slider--navigation")) {
      if (document.querySelector(".c-slider--navigation").style.display !== 'none') {
        this.lightboxImages = document.querySelectorAll(".c-lightbox__image");
      }
      if (this.swiperElement.classList.contains("c-slider--navigation")) {
        this.swiperFractionBox = document.querySelector(".swiper-pagination-top-2");
      }


    }

    if (this.swiperFractionBox) {
      this.swiperFractionIndex = 1;
      this.swiperFractionTotal =  document.querySelectorAll(".o-sticky__slider .c-slider__slide").length;
      this.swiperFractionBox.innerHTML= this.swiperFractionIndex + "/"+ this.swiperFractionTotal ;

    }

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth > 960) {
      this.isMobil=false;
    }else {
      this.isMobil=true;
    }
  }

  unmount() {
    this.destroy(this.swiper, true);
  }
}
